import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';
import type { Lib, TypeExportData } from '@/app/editor/iframe/atom/Atom.model';
import type { TypeInteractionExport } from '@/app/editor/sidebar/interactions/type';
import HELPER from '@/app/utils/HELPER';
import type { Atom } from '@/app/editor/iframe/atom/Atom';
import type { AtomExportInterface } from '@/app/editor/iframe/atom/atom-interface/AtomExportInterface';
import { SCROLL_VIEW_KEY } from '@/app/editor/sidebar/constant';

declare let Liquid: any;
/**
 * AtomServiceExportData
 */
export class AtomServiceExportData implements AtomExportInterface {
  public atom: Atom;

  /**
   * AtomServiceExportData
   * @param atom atom
   */
  constructor(atom: Atom) {
    this.atom = atom;
  }

  /**
   * exportMe
   * @param $this :any
   * @param exportType :string
   * @returns data
   */
  export(exportType?: string): TypeExportData {
    const _this = this.atom;
    // Get data từ DataManager
    const dataSetting = DataManager.getDataSetting(this.atom.getId());

    // Định nghĩa khởi tạo
    let libs: Array<Lib> = this.atom.getLibs();
    let fonts: Array<string> = [];
    let script = dataSetting.atom.script;
    let style = dataSetting.atom.style;
    let html = dataSetting.atom.html;
    let bkHtml = '';

    // --------------------------------------------------------------------
    // Lấy bkContent hiện tại của atom
    const moduleId = this.atom.getId();
    let $bkContent: any;
    // eslint-disable-next-line prefer-const
    $bkContent = HELPER.mergeDataSetting('module', moduleId);
    const $bkModuleHtml = jQuery('<div />').html($bkContent);
    bkHtml += $bkModuleHtml.html();

    // Lấy wapper atom và render childs và liquid
    let $atomClone = this.atom.$el.clone();
    // check doExportMe() trong gfModule() để override phần render tương ứng
    $atomClone = this.renderTemplateExport($atomClone, html, exportType);

    //clone all child inside this atom
    $atomClone.find('.item-content').each(function (this: HTMLElement) {
      const $that = jQuery(this);
      $that.children('.gf_row').each(function (this: HTMLElement) {
        const rowId = jQuery(this).attr('data-id');
        const $thisRow = _this.$gryffBody.find('#r-' + rowId);
        if ($thisRow && $thisRow.length > 0) {
          if ($thisRow.data('gfrow') != undefined) {
            const data = $thisRow.data('gfrow').exportMe(exportType);
            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
            style += data.style;
            script += data.script;
            libs = libs.concat(data.libs);
            fonts = fonts.concat(data.fonts);
          }
        }
      });
      $that.children('.module-wrap').each(function () {
        const moduleId = jQuery(this).attr('data-id');
        const $thisModule = _this.$gryffBody.find('#m-' + moduleId);
        if ($thisModule && $thisModule.length > 0) {
          if ($thisModule.data('gfmodule') != undefined) {
            const data = $thisModule.data('gfmodule').exportMe(exportType);
            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
            style += data.style;
            script += data.script;
            libs = libs.concat(data.libs);
            fonts = fonts.concat(data.fonts);
          }
        }
      });
      $that.children('.element-wrap').each(function () {
        const elementId = jQuery(this).attr('data-id');
        const $thisElement = _this.$gryffBody.find('#e-' + elementId);
        if ($thisElement && $thisElement.length > 0) {
          if ($thisElement.data('gfelement') != undefined) {
            const data = $thisElement.data('gfelement').exportMe(exportType);
            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
            style += data.style;
            script += data.script;
            libs = libs.concat(data.libs);
            fonts = fonts.concat(data.fonts);
          }
        }
      });
    });
    // Interaction
    if ($bkContent && $bkContent.length > 0) {
      const $bkClone = $bkContent.clone();
      if ($bkClone.find('.interaction').text()) {
        const interactionData = $bkClone.find('.interaction').text();
        script += this.parseInteraction2Scripts($atomClone, interactionData, exportType);
      }
    }

    // Lấy html từ clone và xử lý
    const $atomHtmlWrap = jQuery('<div />').append($atomClone);
    html = $atomHtmlWrap.html();
    html = HELPER.clearExportedData(html);
    html = HELPER.compressHTML(html);
    html = HELPER.simpleHTMLEntities(html);

    style = HELPER.compressHTML(style);

    // check defineds
    script = script == 'undefined' ? '' : script;

    style = style == 'undefined' ? '' : style;
    let data: TypeExportData = {
      html: html,
      bkHtml: bkHtml,
      style: style,
      script: script,
      libs: libs,
      fonts: fonts,
    };
    data = this.formatDataAtomInExport(data);
    return data;
  }

  /**
   * renderTemplateExport
   * @param $atomClone :JQuery
   * @param html :string
   * @param exportType :string
   * @returns html
   */
  renderTemplateExport($atomClone: JQuery, html: string, exportType?: string): JQuery {
    html = this.atom.atomRender.renderSettings(html);
    if (this.atom.$el.attr('data-compile') != 'false' && this.atom.getLabel() != 'Liquid') {
      const tmpl = Liquid.parse(html);
      html = tmpl.render({
        items: this.atom.data.atom.data['items'],
      });
    }
    return $atomClone.html(html);
  }

  /**
   * parseInteraction2Scripts
   * @param $atomClone dom atom clone when export
   * @param interaction object interaction in bk content
   * @param exportType type of export: clone, ...
   * @returns script
   */
  parseInteraction2Scripts($atomClone: JQuery, interaction: string, exportType?: string): string {
    let script = '';
    let interactionJSON: TypeInteractionExport;
    try {
      interactionJSON = JSON.parse(interaction);
    } catch {
      interactionJSON = {
        animations: [],
      };
    }
    if (interactionJSON && interactionJSON.animations && interactionJSON.animations.length) {
      interactionJSON.animations.forEach((e) => {
        try {
          const animationName = e.animation.name;
          const interaction: any = e.interaction;

          if (exportType != 'clone') {
            if (animationName && animationName.includes('_in') && SCROLL_VIEW_KEY.includes(interaction.key) ) {
              $atomClone.css('opacity', 0);
            }
            if (animationName && animationName.includes('_out')) {
              // Do nothing
            }
          }

          if (interaction) {
            switch (interaction.key) {
              case 'mouse-click':
                script += `window.__gfAnimate.registerClick(jQuery("${this.atom.getIdNode()}"), '${JSON.stringify(
                  e,
                )}');`;
                break;
              case 'mouse-hover':
                script += `window.__gfAnimate.registerHover(jQuery("${this.atom.getIdNode()}"), '${JSON.stringify(
                  e,
                )}');`;
                break;
              case 'mouse-leave':
                script += `window.__gfAnimate.registerMouseLeave(jQuery("${this.atom.getIdNode()}"), '${JSON.stringify(
                  e,
                )}');`;
                break;
              case 'after-page-loaded':
                script += `window.__gfAnimate.registerPageLoaded(jQuery("${this.atom.getIdNode()}"), '${JSON.stringify(
                  e,
                )}');`;
                break;
              case 'scroll-into-view':
                script += `window.__gfAnimate.registerScroll(jQuery("${this.atom.getIdNode()}"), '${JSON.stringify(
                  e,
                )}');`;
                break;
              case 'scrolling-in-view':
                script += `window.__gfAnimate.registerScrolling(jQuery("${this.atom.getIdNode()}"), '${JSON.stringify(
                  e,
                )}');`;
                break;
            }
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('error export animation', e);
        }
      });
    }
    return script;
  }

  /**
   * formatDataAtomInExport
   * @param data export
   * @returns data export
   */
  formatDataAtomInExport(data: TypeExportData): TypeExportData {
    return data;
  }

  /**
   * get$bkCloneHtml
   * @param $bkClone $bkClone
   * @returns returns
   */
  get$bkCloneHtml($bkClone: JQuery): JQuery {
    const $bk = jQuery('<div />').append($bkClone);
    return $bk;
  }
}
